import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import {faFacebook, faYoutube} from '@fortawesome/free-brands-svg-icons'
import {faChevronLeft, faPen, faChevronRight, faMagnifyingGlass, faArrowLeft, faArrowRight} from '@fortawesome/free-solid-svg-icons'
import YouTube from 'vue3-youtube'

import VueGoogleMaps from '@fawmi/vue-google-maps'

import Toast, {PluginOptions, POSITION} from "vue-toastification";
import "vue-toastification/dist/index.css";

import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'

library.add(faFacebook)
library.add(faChevronLeft)
library.add(faPen)
library.add(faYoutube)
library.add(faChevronRight)
library.add(faMagnifyingGlass)

library.add(faArrowLeft)
library.add(faArrowRight)

const toastOptions: PluginOptions = {
    position: POSITION.BOTTOM_RIGHT
};


createApp(App)
    .use(store)
    .use(router)
    .use(Toast, toastOptions)
    .use(VueGoogleMaps, {
        load: {
            key: process.env.VUE_APP_GOOGLE_MAPS_API,
            libraries: "places"
        },
    })
    .use(PerfectScrollbar)
    .component('YouTube', YouTube)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
